module.exports = __webpack_public_path__ + "img/Flag_of_the_Central_African_Republic.1f543881.svg";